// extracted by mini-css-extract-plugin
export var active = "_bh-d";
export var blink = "_bh-e";
export var container = "_bh-5";
export var controls = "_bh-0";
export var controlsRight = "_bh-1";
export var fakeCursor = "_bh-c";
export var hidden = "_bh-b";
export var quillContainerSmall = "_bh-7";
export var quillEditor = "_bh-6";
export var quillEditorSmall = "_bh-8";
export var quillFormatButtons = "_bh-a";
export var quillToolbar = "_bh-9";
export var removePadding = "_bh-2";
export var state = "_bh-3";
export var stateTitle = "_bh-4";